const state = {
  nav: [] // 菜单
}

const mutations = {
  SET_DATA: (state, data) => {
    state.nav = data.nav
  }
}

const actions = {
  setData({ commit }, params) {
    commit('SET_DATA', params)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
